<template>
    <v-dialog
        v-model="modalDialogOrganizacao"
        scrollable
        max-width="750"
    >
        <v-card>
            <v-toolbar 
                dark 
                color="secondary"
            >
                <v-btn 
                    icon 
                    dark 
                    @click="modalDialogOrganizacao = false"
                >
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>
                    Detalhes da Inscrição
                    <v-chip
                        color="grey"
                        style="margin-left:250px"
                    >
                        Pontuação inicial:&nbsp;
                        <b v-if="isLoadingEntidade">
                            <v-progress-circular
                                :width="1"
                                :size="10"
                                indeterminate
                            />
                        </b>
                        <b v-else>
                            {{ organizacao.pontuacao }}
                        </b>
                    </v-chip>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="isLoadingEntidade">
                <v-progress-linear indeterminate height="5" />
            </v-card-text>
            <v-card-text v-else>
                <organizacao-detalhes-inscricao-visualizacao/>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import OrganizacaoDetalhesInscricaoVisualizacao from '../OrganizacaoDetalhesInscricaoVisualizacao';

export default{
    name: 'OrganizacaoDetalhesInscricaoVisualizacaoDialog',
    components:{
        OrganizacaoDetalhesInscricaoVisualizacao
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        isLoading:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            modalDialogOrganizacao: false,
            isLoadingEntidade: false,
        }
    },
    computed: {
        ...mapGetters({
            organizacao: 'organizacao/organizacao'
        })
    },
    watch: {
        value(alternarDialogoAtivo){
            this.modalDialogOrganizacao = alternarDialogoAtivo;
        },
        modalDialogOrganizacao(alternarDialogoAtivo){
            this.$emit('input', alternarDialogoAtivo);
        },
        organizacao(){
            this.isLoadingEntidade = false;
        },
        isLoading(alternarCarregamento){
            this.isLoadingEntidade = alternarCarregamento;
        }
    },
}
</script>